import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';

import TagManager from 'react-gtm-module';
import { logger } from './helpers/logger';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  auth: process.env.REACT_APP_GTM_AUTH,
  preview: process.env.REACT_APP_GTM_ENV,
};
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    {logger.log(
      `################## App V.${process.env.REACT_APP_VER} - ${process.env.REACT_APP_ENV} ##################`
    )}
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
